import api from "@/services/api";
import { Promise } from "core-js";

const BASE_URL = "/audit";

//#region state
const state = {
  auditLogs: [],
  entityHistory: [],
  entityTypes: [],
  totalItems: 0,
  totalPages: 0,
};
//#endregion

//#region getters
const getters = {};
//#endregion

//#region actions
const actions = {
  async getAll(context, params = {}) {
    try {
      const response = await api.get(`${BASE_URL}/logs`, params);
      if (response.status === 200) {
        context.commit("SET_AUDIT_LOGS", response.data.content);
        context.commit("SET_TOTAL_ITEMS", response.data.totalElements);
        context.commit("SET_TOTAL_PAGES", response.data.totalPages);
      }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getEntityHistory(context, { entityType, entityId }) {
    try {
      const response = await api.get(`${BASE_URL}/entity/${entityType}/${entityId}`);
      if (response.status === 200) {
        context.commit("SET_ENTITY_HISTORY", response.data);
      }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getEntityTypes(context) {
    try {
      const response = await api.get(`${BASE_URL}/entity-types`);
      if (response.status === 200) {
        context.commit("SET_ENTITY_TYPES", response.data);
      }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  clearEntityHistory(context) {
    context.commit("SET_ENTITY_HISTORY", []);
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_AUDIT_LOGS(state, payload) {
    state.auditLogs = payload;
  },
  SET_ENTITY_HISTORY(state, payload) {
    state.entityHistory = payload;
  },
  SET_ENTITY_TYPES(state, payload) {
    state.entityTypes = payload;
  },
  SET_TOTAL_ITEMS(state, payload) {
    state.totalItems = payload;
  },
  SET_TOTAL_PAGES(state, payload) {
    state.totalPages = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
